module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp2_8011.3cb7e86c.png";